import * as React from "react";
import PropTypes from "prop-types";
import { Card, Box } from "@mui/material";

export default function CardImageBackground({
                                                imageSrc,
                                                alt = "",
                                                height,
                                                borderRadius = 4,
                                                overlayColor = "#000",
                                                overlayOpacity = 0.35,
                                                brightness,
                                                darken = false,

                                                content,
                                                contentAlign = "center",
                                                contentJustify = "flex-end",
                                                contentPadding = 2,

                                                sx,
                                                imageSx,
                                                overlaySx,
                                                contentSx,

                                                ...cardProps
                                            }) {
    const computedBrightness =
        typeof brightness === "number" ? brightness : darken ? 0.75 : undefined;

    return (
        <Card
            elevation={0}
            {...cardProps}
            sx={{
                width: "100%",
                borderRadius,
                overflow: "hidden",
                position: "relative",
                height,
                ...sx,
            }}
        >
            {/* Background image layer (absolute) */}
            <Box
                aria-label={alt}
                role={alt ? "img" : undefined}
                sx={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 0,
                    backgroundImage: `url(${imageSrc})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    transform: "scale(1.02)",
                    filter:
                        computedBrightness != null
                            ? `brightness(${computedBrightness})`
                            : undefined,
                    ...imageSx,
                }}
            />

            {/* Overlay tint layer */}
            {overlayOpacity > 0 && (
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        zIndex: 1,
                        backgroundColor: overlayColor,
                        opacity: overlayOpacity,
                        pointerEvents: "none",
                        ...overlaySx,
                    }}
                />
            )}

            {/* Content layer */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: contentJustify,
                    alignItems:
                        contentAlign === "left"
                            ? "flex-start"
                            : contentAlign === "right"
                                ? "flex-end"
                                : "center",
                    p: contentPadding,
                    color: "#fff", // sensible default so text shows on dark overlay
                    pointerEvents: "none",
                    ...contentSx,
                }}
            >
                {content}
            </Box>
        </Card>
    );
}

CardImageBackground.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    alt: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    overlayColor: PropTypes.string,
    overlayOpacity: PropTypes.number,
    brightness: PropTypes.number,
    darken: PropTypes.bool,
    content: PropTypes.node,
    contentAlign: PropTypes.oneOf(["left", "center", "right"]),
    contentJustify: PropTypes.oneOf(["flex-start", "center", "flex-end"]),
    contentPadding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sx: PropTypes.object,
    imageSx: PropTypes.object,
    overlaySx: PropTypes.object,
    contentSx: PropTypes.object,
};
